import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import MainLayout from './main-layout';
import Booking from '@components/booking';
import SearchCategories from '@components/search-categories/search-categories';
import '@fontsource-variable/oswald';
import './index.css';
import SearchRegion from './components/search-region/search-region';
import SearchHome from './components/search-home/search-home';
import Sales from './components/sales/sales';
import Article from './components/article/article';
import BookingOrder from './components/booking-order';
import NotFound from './components/not-found/not-found';
import { useDispatch, useSelector } from 'react-redux';
import { serverFetch } from './server';
import { userLoaded } from './store/actions';
import { message } from 'antd';
import Vk from './components/auth/vk';
// import Sberpay from './components/widgets/sberpay';

const App = () => {
    //document.title = "Сервис онлайн бронирования КУПИТЬ ПУТЁВКУ";

    const d = useDispatch();
    const user = useSelector((s:any) => s.user);
    const location = useLocation();
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const ptag = searchParams.get(process.env.REACT_APP_UTM_TAG_NAME || "");
        if (ptag !== (sessionStorage.getItem(process.env.REACT_APP_UTM_TAG_NAME || "")))
            sessionStorage.setItem(process.env.REACT_APP_UTM_TAG_NAME || "", ptag || "");

        const paramValue = searchParams.get(process.env.REACT_APP_VK_PARAM_NAME || "");
        const sess = sessionStorage.getItem(process.env.REACT_APP_VK_PARAM_NAME || "");
        if (paramValue && (!sess || paramValue !== sess)) {
            // Проверить - если пользователь не авторизован а есть флаг авторизации то пытаемся
            if(!user) {
                sessionStorage.setItem(process.env.REACT_APP_VK_PARAM_NAME || "", paramValue);
                const bodyData = JSON.parse(atob(paramValue));
                //message.info("bodyData");
                if (bodyData && bodyData.vkauth) {
                    // Авторизуем пользователя
                    serverFetch(`vk/sign`, { method: 'POST', bodyData })
                        .then(data => d(userLoaded(data)))
                        .catch(() => message.error('Ошибка входа. Попробуйте перегрузить страницу и предоставить доступ приложению до данных почты и телефона'));
                }
            }
            else {
                d(userLoaded(null));
            }
        }
    }, [location.search, user]);

    return (
        <Routes>
            <Route path='/' element={<MainLayout />}>
                <Route path='/' element={<SearchHome />} />
                <Route path={'booking/:id'} element={<Booking />} />
                <Route path='booking/order/:companyId' element={<BookingOrder />} />
                <Route path={'booking/search/category/:companyId'} element={<SearchCategories />} />
                <Route path={'module/booking/search/category/:companyId'} element={<SearchCategories />} />
                <Route path={'home/company/:companyId'} element={<SearchCategories />} />
                <Route path={'booking/search/region/:regionAlias'} element={<SearchRegion />} />
                <Route path='sales' element={<Sales />} />
                <Route path='article/:url' element={<Article />} />                
                <Route path='/vk' element={<Vk />} />
                {/* <Route path='/widgets/sberpay' element={<Sberpay />} /> */}
                <Route path="*" element={<NotFound />} />
            </Route>
        </Routes>
    );
};

export default App;